import styled from 'styled-components';

const CheckboxList = styled.div`
  display: flex;
  flex-direction: column;
  & > * {
    margin-bottom: 0.75rem;
  }
`;
export default CheckboxList;
